import { useAuthContext } from "@eisox/auth";
import { createFileRoute } from "@tanstack/react-router";

import { MyAccountPage } from "~/features/account";
import { documentTitleHead } from "~/helpers/document-title.helper";
import { m } from "~/paraglide/messages";

export const Route = createFileRoute("/_authenticated/_no-building/account")({
  head: () => documentTitleHead({ page: m.my_acccount() }),
  component: RouteComponent,
});

function RouteComponent() {
  const { user } = useAuthContext(Route.id);

  if (!user) return null;

  return <MyAccountPage user={user} />;
}
